export const CustomIconDefaultConfig = {
  width: "1rem",
  height: "1rem",
};
